module.exports = __webpack_public_path__ + "static/media/Location_Book-Page33.4a04efd1.png";